import { render } from "./ZhiZaoKanBan2.vue?vue&type=template&id=f775cfb0&scoped=true"
import script from "./ZhiZaoKanBan2.vue?vue&type=script&lang=js"
export * from "./ZhiZaoKanBan2.vue?vue&type=script&lang=js"

import "./ZhiZaoKanBan2.vue?vue&type=style&index=0&id=f775cfb0&scoped=true&lang=css"

import exportComponent from "/Users/tinypocket/workspace/joysun/repositories/joysun-ems/joysun-ems-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f775cfb0"]])

export default __exports__